// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__fOWeX","label":"Labeled_label__1AWtg","divider":"Labeled_divider__3imig"};